import cfg from 'cfg';
import { requestAsync } from 'redux-query';
import merge from 'lodash.merge';
import { httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import auth from 'dash-front/auth';
import { toIdMap } from 'dash-front/helpers';

const defaultPermissions = {
    htmlWidgets: false,
    smWidgets: false,
    campaigns: false
};

const mapDataToServer = account => {
    account.permissions = merge({}, defaultPermissions, account.permissions);
    return account;
};

export const createAccount = account =>
    requestAsync({
        url: `/api/users?access_token=${auth.getAccessToken()}`,
        body: mapDataToServer(account),
        force: true,
        queryKey: 'POST:accounts',
        transform: res => ({
            accounts: { [res.username]: res }
        }),
        update: {
            accounts: UPDATE_DEFAULT.MERGE
        },
        options: {
            method: httpMethods.POST
        }
    });

export const fetchAccountConfig = () => ({
    url: `/api/users/all?access_token=${auth.getAccessToken()}`,
    force: true,
    queryKey: 'GET:accounts',
    transform: res => ({
        accounts: res.reduce((acc, cur) => {
            acc[cur.username] = cur;
            return acc;
        }, {})
    }),
    update: {
        accounts: UPDATE_DEFAULT.MERGE
    }
});

export const fetchUsers = () =>
    requestAsync({
        url: `/api/users/all?access_token=${auth.getAccessToken()}`,
        force: true,
        queryKey: 'GET:accounts',
        transform: res => ({
            users: toIdMap(res)
        }),
        update: {
            users: UPDATE_DEFAULT.MERGE
        }
    });

export const fetchUserByNameConfig = username => ({
    url: `/api/users/${username}?access_token=${auth.getAccessToken()}`,
    force: true,
    queryKey: `GET:accounts/${username}`,
    transform: res => ({
        accounts: { [res.username]: res }
    }),
    update: {
        accounts: UPDATE_DEFAULT.MERGE
    }
});

export const updateAccount = (userId, value) =>
    requestAsync({
        url: `/api/users/${userId}?access_token=${auth.getAccessToken()}`,
        force: true,
        body: value,
        queryKey: `PUT:accounts/${userId}`,
        transform: res => ({
            accounts: { [res.username]: res }
        }),
        update: {
            accounts: UPDATE_DEFAULT.MERGE
        },
        options: {
            method: httpMethods.PUT
        }
    });

export const fetchAccountPacks = () => ({
    url: `${cfg.dash.api.host}/api/admin/packs?access_token=${auth.getAccessToken()}`,
    force: true,
    queryKey: 'GET:accountPacks',
    transform: body => ({
        accountPacks: body.reduce((acc, el) => {
            acc[el._id] = el;
            return acc;
        }, {})
    }),
    update: {
        accountPacks: UPDATE_DEFAULT.MERGE
    },
    options: {
        method: httpMethods.GET
    }
});

export const updateAccountPacks = (userId, value) =>
    requestAsync({
        url: `/api/users/${userId}?access_token=${auth.getAccessToken()}`,
        force: true,
        body: value,
        queryKey: `PUT:accounts/${userId}`,
        transform: res => ({
            accounts: { [res.username]: res }
        }),
        update: {
            accounts: UPDATE_DEFAULT.MERGE
        },
        options: {
            method: httpMethods.PUT
        }
    });



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/actions/accounts.js
 **/